import { BriefSection } from "../BriefSection";

interface BriefStageProps {
  campaignId: string;
}

export function BriefStage({ campaignId }: BriefStageProps) {
  return <BriefSection campaignId={campaignId} />;
}
